import { render, staticRenderFns } from "./Trucks.vue?vue&type=template&id=0644a542&"
import script from "./Trucks.vue?vue&type=script&lang=ts&"
export * from "./Trucks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports